import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Bedankt voor uw beoordeling!',
  text: 'Is er iets dat we kunnen verbeteren? Deel uw mening met ons.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Uw mening...'
      }
    ],
    submit: {
      label: 'Verzenden'
    }
  }
};